module.exports = __webpack_public_path__ + "img/ico-add.305a7d89.svg";